// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
// import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";
import { FaLocationDot } from "react-icons/fa6";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="Assets/banner1.webp"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            Al Ghaf Tower by Tiger Properties
          </h2>
          <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">At Al Khan Beach, Sharjah</span>
          </div>
          <p>
            Al Ghaf Tower by Tiger Properties is a striking 50-floor beachfront landmark rising along Al Khan Beach, Sharjah. Blending heritage-inspired design with modern luxury, the tower offers fully furnished 1 to 4-bedroom apartments and exclusive 4-bedroom duplexes, all designed to capture panoramic sea and skyline views. Residents enjoy resort-style amenities including an infinity pool overlooking the Arabian Gulf, a state-of-the-art fitness center, and landscaped leisure spaces. With premium finishes and a prime coastal location, Al Ghaf Tower delivers a serene yet connected beachfront lifestyle. 
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
